// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"a3c9075c","140":"b7b3709e","322":"c364605d","375":"4f191bf3","447":"90456b3d","538":"a51634c1","706":"471c6f9b"}[chunkId] + ".chunk.js";
};